import Api from '@/services/api';
import {removeEmptyParams} from '../utils';

export default {
  priceRulesByAccommodationId(accommodationId, params) {
    return Api()
      .get(`/accommodations/${accommodationId}/prices`, {params: removeEmptyParams(params)})
      .then((res) => {
        console.log(res);
        this.formatRes(res.data);
        return res.data;
      });
  },

  priceRulesByAccommodationIdAsMap(accommodationId, params) {
    return Api()
      .get(`/accommodations/${accommodationId}/prices/map`, {params: removeEmptyParams(params)})
      .then((res) => {
        this.formatRes(res.data);
        return res.data;
      });
  },

  update(priceRules) {
    return Api()
      .put(`/accommodations/${priceRules.accommodationId}/prices`, priceRules)
      .then((res) => {
        this.formatRes(res.data);
        return res.data;
      });
  },

  // requestBody = {fields, key}
  updateMapForAccommodation(accommodationId, requestBody) {
    return Api()
      .put(`/accommodations/${accommodationId}/prices/map`, requestBody)
      .then((res) => {
        this.formatRes(res.data);
        return res.data;
      });
  },

  syncForAccommodation(accommodationId) {
    return Api()
      .put(`/accommodations/${accommodationId}/prices/sync`, {})
      .then(() => {});
  },

  updateForRM(accommodationId, mandatDTO) {
    return Api()
      .put(`/accommodations/${accommodationId}/prices/rm`, mandatDTO)
      .then(() => {});
  },

  addPeriod(pricePeriod) {
    return Api()
      .post(`/accommodations/${pricePeriod.accommodationId}/prices/period`, pricePeriod)
      .then((res) => {
        this.formatRes(res.data);
        return res.data;
      });
  },

  formatRes(e) {
    return e;
  },
};
